import { Color } from 'csstype';
import React from 'react';
import { DefaultTheme } from 'styled-components';
import { colors } from 'theme';

interface IProps {
  theme?: DefaultTheme;
  color?: Color;
  width?: number | string;
  height?: number | string;
  className?: string;
  onClick?: () => void;
  ref?: any;
}

export const ArrowLeft = ({
  color = colors.primary,
  width = 11,
  height = 18,
  className = '',
  rotate = 0,
  onClick,
}: IProps & { rotate?: number }) => (
  <svg
    onClick={onClick}
    width={width}
    height={height}
    viewBox={`-6 -3 24 24`}
    className={className}
  >
    <path
      fill={color}
      d="M10.5113895,15.2416107 L4.02999241,8.99194631 L10.5113895,2.74228188 C11.1628702,2.11409396 11.1628702,1.09932886 10.5113895,0.47114094 C9.85990888,-0.15704698 8.80751708,-0.15704698 8.15603645,0.47114094 L0.488610478,7.86442953 C-0.162870159,8.49261745 -0.162870159,9.50738255 0.488610478,10.1355705 L8.15603645,17.5288591 C8.80751708,18.157047 9.85990888,18.157047 10.5113895,17.5288591 C11.1461655,16.9006711 11.1628702,15.8697987 10.5113895,15.2416107 Z"
    />
  </svg>
);

export const Less = ({
  color = colors.primary,
  width = 12,
  height = 12,
  className = '',
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 12 12`}
      className={className}
    >
      <path
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        d="M2,6 L10,6"
      />
    </svg>
  );
};

export const Check = ({
  color = colors.primary,
  width = 20,
  height = 20,
  className = '',
  ...rest
}: IProps) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 -3 12 12"
      className={className}
    >
      <path
        fill={color}
        d="M0.430391036,5.74503552 C-0.885853811,4.40003055 1.11562662,2.355023 2.43187147,3.70002797 L4.14952338,5.45503445 L8.5197684,0.491367477 C9.76181577,-0.918637727 11.8627552,1.01339643 10.6207079,2.42340164 L5.30388281,8.46220771 C4.77563905,9.12896693 3.79797808,9.18572389 3.20175303,8.57653245 L0.430391036,5.74490038 L0.430391036,5.74503552 Z"
      />
    </svg>
  );
};

export const Spinner = ({
  theme,
  color = colors.primary,
  width = 18,
  className = '',
}: IProps) => {
  return (
    <svg className={className} width={width} height={width}>
      <circle fill={color} stroke="none" cx="6" cy="20" r="6">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.1"
        />
      </circle>
      <circle fill={color} stroke="none" cx="26" cy="20" r="6">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.2"
        />
      </circle>
      <circle fill={color} stroke="none" cx="46" cy="20" r="6">
        <animate
          attributeName="opacity"
          dur="1s"
          values="0;1;0"
          repeatCount="indefinite"
          begin="0.3"
        />
      </circle>
    </svg>
  );
};

export const Close = ({
  color = colors.primary,
  width = 11,
  height = 14,
  className = '',
}: IProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 9 12" className={className}>
      <defs>
        <path
          d="M7.31266357,0.682693914 C7.62779229,0.229138695 8.25093374,0.116921843 8.70448896,0.432050559 C9.15804418,0.747179276 9.27026103,1.37032073 8.95513232,1.82387595 L8.95513232,1.82387595 L6.06641698,5.980196 L8.95513232,10.1378209 C9.27026103,10.5913762 9.15804418,11.2145176 8.70448896,11.5296463 C8.25093374,11.844775 7.62779229,11.7325582 7.31266357,11.279003 L4.84841698,7.732196 L2.38574028,11.279003 C2.09485224,11.6976693 1.54151547,11.8254912 1.1013745,11.5948215 L0.993914894,11.5296463 C0.540359675,11.2145176 0.428142823,10.5913762 0.743271539,10.1378209 L0.743271539,10.1378209 L3.63141698,5.980196 L0.743271539,1.82387595 C0.428142823,1.37032073 0.540359675,0.747179276 0.993914894,0.432050559 C1.44747011,0.116921843 2.07061156,0.229138695 2.38574028,0.682693914 L4.84841698,4.228196 Z"
          id="path-1"
        ></path>
      </defs>
      <g
        id="Atoms/Icons/x"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Color/grey" transform="translate(-0.112664, 0.000000)">
          <mask id="mask-2" fill="white">
            <use href="#path-1"></use>
          </mask>
          <use id="Mask" fill={color} fillRule="nonzero" href="#path-1"></use>
          <g id="Color/blue" mask="url(#mask-2)" fill={color}>
            <g transform="translate(-1.000000, -1.000000)" id="Rectangle">
              <rect x="0" y="0" width={width} height={height}></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Person = ({
  color = colors.lightPrimary,
  height = 12,
  className = '',
}: IProps) => {
  return (
    <svg
      width={height}
      height={height}
      viewBox={`0 0 12 12`}
      className={className}
    >
      <g
        id="Atoms/Icons/Personne"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M5.5,-2.69118061e-13 C7.05517241,-2.69118061e-13 8.30689655,1.29216867 8.30689655,2.89759036 C8.30689655,4.50301205 7.05517241,5.79518072 5.5,5.79518072 C3.94482759,5.79518072 2.69310345,4.50301205 2.69310345,2.89759036 C2.69310345,1.29216867 3.94482759,-2.69118061e-13 5.5,-2.69118061e-13 Z"
          id="Path"
          fill={color}
        ></path>
        <path
          d="M5.5,6.69578313 C8.53448276,6.69578313 11,9.24096386 11,12.373494 C11,12.6084337 11,12.8042169 10.962069,13 L0.0379310345,13 C0,12.8042169 0,12.6084337 0,12.373494 C0,9.24096386 2.46551724,6.69578313 5.5,6.69578313 Z"
          id="Path"
          fill={color}
        ></path>
      </g>
    </svg>
  );
};

export const History = ({
  color = colors.primary,
  width = 17,
  height = 15,
}: IProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Atoms/Icons/History"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="noun_History_2839832" fill={color} fillRule="nonzero">
        <g id="Group">
          <path
            d="M3.67920998,7.38676507 C3.67920998,7.098071 3.69864865,6.80937693 3.73752599,6.52241156 C3.72692308,6.59847467 3.71632017,6.67626649 3.70571726,6.75232959 C3.78347193,6.18185628 3.93898129,5.62348391 4.16517672,5.09277086 C4.13513514,5.16191914 4.10509356,5.23106742 4.07681913,5.298487 C4.3012474,4.77987489 4.59282744,4.29237951 4.94272349,3.8463731 C4.89677755,3.90514914 4.8508316,3.96219647 4.80488565,4.02097251 C5.1547817,3.57842352 5.55945946,3.18254961 6.01185031,2.83853692 C5.95176715,2.8834833 5.89345114,2.92842968 5.83336798,2.97337606 C6.28929314,2.62936337 6.78762994,2.34412671 7.31777547,2.12458092 C7.2470894,2.15396894 7.17640333,2.18335696 7.10748441,2.21101627 C7.65,1.98801307 8.22079002,1.83761556 8.8039501,1.75982374 C8.72619543,1.77019598 8.6466736,1.78056822 8.56891892,1.79094047 C9.15561331,1.71660606 9.7493763,1.71660606 10.3343035,1.79094047 C10.2565489,1.78056822 10.177027,1.77019598 10.0992723,1.75982374 C10.6824324,1.83588685 11.2532225,1.98801307 11.795738,2.20928756 C11.725052,2.17989954 11.6543659,2.15051152 11.585447,2.12285221 C12.1155925,2.342398 12.6139293,2.62763466 13.0698545,2.96991865 C13.0097713,2.92497227 12.9514553,2.88002588 12.8913721,2.8350795 C13.343763,3.17736349 13.7484407,3.5732374 14.0983368,4.01578639 C14.0523909,3.95701035 14.0064449,3.89996302 13.960499,3.84118698 C14.310395,4.28719339 14.6019751,4.77468877 14.8264033,5.29330088 C14.7963617,5.22415259 14.7663202,5.15500431 14.7380457,5.08758474 C14.9660083,5.61829779 15.1197505,6.17667016 15.1975052,6.74714347 C15.1869023,6.67108036 15.1762994,6.59328855 15.1656965,6.51722544 C15.241684,7.09115617 15.241684,7.67200173 15.1656965,8.24420375 C15.1762994,8.16814064 15.1869023,8.09034882 15.1975052,8.01428571 C15.1197505,8.58475903 14.9642412,9.14313139 14.7380457,9.67384445 C14.7680873,9.60469617 14.7981289,9.53554789 14.8264033,9.46812831 C14.6019751,9.98674042 14.310395,10.4742358 13.960499,10.9202422 C14.0064449,10.8614662 14.0523909,10.8044188 14.0983368,10.7456428 C13.7484407,11.1881918 13.343763,11.5840657 12.8913721,11.9263497 C12.9514553,11.8814033 13.0097713,11.8364569 13.0698545,11.7915105 C12.6139293,12.1337945 12.1155925,12.4190312 11.585447,12.638577 C11.6561331,12.609189 11.7268191,12.5798009 11.795738,12.5521416 C11.2532225,12.7751448 10.6824324,12.9255423 10.0992723,13.0016054 C10.177027,12.9912332 10.2565489,12.980861 10.3343035,12.9704887 C9.745842,13.0465518 9.1485447,13.0448231 8.56008316,12.96876 C8.63783784,12.9791323 8.71735967,12.9895045 8.79511435,12.9998767 C8.21372141,12.9220849 7.64469854,12.7716874 7.1039501,12.5504129 C7.17463617,12.5798009 7.24532225,12.609189 7.31424116,12.6368483 C6.78586279,12.4190312 6.28929314,12.1355232 5.83513514,11.7932392 C5.8952183,11.8381856 5.9535343,11.883132 6.01361746,11.9280784 C5.56299376,11.5875231 5.15831601,11.1916492 4.80841996,10.7525576 C4.8543659,10.8113337 4.90031185,10.868381 4.9462578,10.927157 C4.93035343,10.9064125 4.91444906,10.8856681 4.8985447,10.8666523 C4.84376299,10.7663873 4.76777547,10.6851381 4.67058212,10.6246333 C4.58575884,10.5485702 4.48503119,10.496709 4.37016632,10.4707784 C4.15810811,10.413731 3.87713098,10.4396617 3.68981289,10.5572137 C3.50072765,10.6764945 3.33461538,10.8528226 3.28336798,11.0740971 C3.23388773,11.2849994 3.23212058,11.5598638 3.37172557,11.7396493 C3.61912682,12.0577314 3.87536383,12.3654413 4.16871102,12.6454918 C4.45322245,12.9186275 4.76600832,13.1641039 5.08939709,13.3940219 C5.69376299,13.82447 6.37588358,14.1494669 7.08274428,14.3828424 C8.47172557,14.8409497 10.025052,14.8720664 11.4387734,14.4952083 C12.7217256,14.1529243 13.9180873,13.4631702 14.845842,12.5296684 C15.7753638,11.5961666 16.4574844,10.4120023 16.7702703,9.1448601 C17.0954262,7.82585665 17.058316,6.40485948 16.6235967,5.11351535 C16.208316,3.87921854 15.4678794,2.74172932 14.4676715,1.88083323 C13.4639293,1.01647972 12.2339917,0.390687785 10.9139293,0.148668803 C9.55322245,-0.100265007 8.11829522,-0.0172870701 6.82120582,0.471937015 C6.1956341,0.708769876 5.6018711,1.00265007 5.06112266,1.39160915 C4.52567568,1.77711081 4.03440748,2.20755886 3.61912682,2.71752743 C3.202079,3.2292247 2.83981289,3.77031 2.57474012,4.37190004 C2.30259875,4.98731973 2.09760915,5.61311167 2.0039501,6.28039258 C1.9527027,6.64860717 1.91382536,7.01336435 1.91205821,7.38503636 C1.91205821,7.60631086 2.01101871,7.83968631 2.17006237,7.99699864 C2.32380457,8.14739615 2.57474012,8.25976211 2.7956341,8.24938987 C3.02359667,8.23901763 3.26039501,8.16641193 3.42120582,7.99699864 C3.58024948,7.82931406 3.67920998,7.62186922 3.67920998,7.38676507 L3.67920998,7.38676507 Z"
            id="Path"
          ></path>
          <path
            d="M5.62307692,4.8300074 C5.24844075,5.03399482 4.87557173,5.23798225 4.50093555,5.44196968 C3.90540541,5.7669666 3.30810811,6.09196352 2.71257796,6.41696043 C2.57474012,6.49129484 2.43866944,6.56562924 2.3008316,6.64169235 C2.7037422,6.74541477 3.10665281,6.84913719 3.50956341,6.9511309 C3.3010395,6.58464501 3.09251559,6.21988783 2.88399168,5.85340195 C2.55176715,5.27082768 2.21954262,4.68652471 1.88731809,4.10395045 C1.81133056,3.9691113 1.73534304,3.83600086 1.65758836,3.70116172 C1.55155925,3.51446136 1.33950104,3.36060643 1.12920998,3.3035591 C0.917151767,3.24651177 0.636174636,3.27244238 0.448856549,3.38999445 C0.25977131,3.50927524 0.0936590437,3.68560335 0.0424116424,3.90687785 C-0.0106029106,4.13679588 0.0123700624,4.36498521 0.130769231,4.57243005 C0.339293139,4.93891594 0.547817048,5.30367312 0.756340956,5.670159 C1.08856549,6.25273327 1.42079002,6.83703624 1.75301455,7.4196105 C1.82900208,7.55444965 1.9049896,7.68756009 1.98274428,7.82239924 C2.21777547,8.23556021 2.78149688,8.3565697 3.19147609,8.13183779 C3.56611227,7.92785036 3.93898129,7.72386294 4.31361746,7.51987551 C4.90914761,7.19487859 5.50644491,6.86988167 6.10197505,6.54488475 C6.23981289,6.47055035 6.37588358,6.39621595 6.51372141,6.32015284 C6.7045738,6.21643042 6.86185031,6.00898558 6.92016632,5.80326944 C6.97848233,5.5958246 6.95197505,5.32096019 6.83180873,5.13771724 C6.70987526,4.95274559 6.52962578,4.79024713 6.30343035,4.74011463 C6.06839917,4.68998213 5.83513514,4.71418403 5.62307692,4.8300074 L5.62307692,4.8300074 Z"
            id="Path"
          ></path>
          <path
            d="M8.56538462,3.97775484 C8.56538462,4.39091581 8.56538462,4.8058055 8.56538462,5.21896647 C8.56538462,5.83784358 8.56538462,6.4584494 8.56538462,7.07732651 C8.56538462,7.41788179 8.54948025,7.70484716 8.82515593,7.99354123 C8.91351351,8.0851627 9.00717256,8.17159805 9.0972973,8.25976211 C9.54968815,8.70231111 10.0003119,9.14313139 10.4527027,9.58568039 C10.7919958,9.91759214 11.1277547,10.2512326 11.4705821,10.5814156 C11.4758836,10.5866018 11.481185,10.5917879 11.4882536,10.5987027 C11.6490644,10.756015 11.8858628,10.8510939 12.1138254,10.8510939 C12.331185,10.8510939 12.5891892,10.7577437 12.7393971,10.5987027 C12.8931393,10.4344755 13.0080042,10.2183872 12.9974012,9.98674042 C12.9867983,9.75682238 12.9072765,9.54073401 12.7393971,9.37477813 C12.4389813,9.08089794 12.1385655,8.78701775 11.8381497,8.49313756 C11.3610187,8.02638666 10.8838877,7.55963577 10.4085239,7.09461358 C10.2989605,6.98743375 10.1876299,6.87852521 10.0780665,6.77134537 C10.164657,6.9753328 10.2512474,7.17932023 10.3360707,7.38330765 C10.3360707,6.9995347 10.3360707,6.61576174 10.3360707,6.23371749 C10.3360707,5.62348391 10.3360707,5.01152163 10.3360707,4.40128806 C10.3360707,4.26126279 10.3360707,4.12123752 10.3360707,3.98121225 C10.3360707,3.75993775 10.2371102,3.52656231 10.0780665,3.36924997 C9.92432432,3.21885246 9.67338877,3.1064865 9.4524948,3.11685875 C9.22453222,3.12723099 8.98773389,3.19983668 8.82692308,3.36924997 C8.66611227,3.53520584 8.56538462,3.74437939 8.56538462,3.97775484 L8.56538462,3.97775484 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const Plus = ({
  color = colors.lightPrimary,
  height = 12,
  className = '',
}: IProps) => {
  return (
    <svg
      width={height}
      height={height}
      viewBox="0 0 13 13"
      className={className}
    >
      <g id="Plus" stroke="none" fill="none">
        <g fill={color} id="Combined-Shape">
          <path d="M6.5,0 C7.05228475,0 7.5,0.44771525 7.5,1 L7.5,1 L7.5,5.5 L12,5.5 C12.5128358,5.5 12.9355072,5.88604019 12.9932723,6.38337887 L13,6.5 C13,7.05228475 12.5522847,7.5 12,7.5 L12,7.5 L7.5,7.5 L7.5,12 C7.5,12.5128358 7.11395981,12.9355072 6.61662113,12.9932723 L6.5,13 C5.94771525,13 5.5,12.5522847 5.5,12 L5.5,12 L5.5,7.5 L1,7.5 C0.487164161,7.5 0.0644928393,7.11395981 0.00672773133,6.61662113 L0,6.5 C0,5.94771525 0.44771525,5.5 1,5.5 L1,5.5 L5.5,5.5 L5.5,1 C5.5,0.487164161 5.88604019,0.0644928393 6.38337887,0.00672773133 Z"></path>
        </g>
      </g>
    </svg>
  );
};

export const Minus = ({
  color = colors.lightPrimary,
  height = 12,
  className = '',
}: IProps) => {
  return (
    <svg
      width={height}
      height={height}
      className={className}
      viewBox="0 0 13 2"
    >
      <g id="moins" stroke="none" fill={color}>
        <path
          d="M12,0 L1,0 C0.44771525,0 0,0.44771525 0,1 C0,1.55228475 0.44771525,2 1,2 L12,2 C12.5522847,2 13,1.55228475 13,1 C13,0.44771525 12.5522847,0 12,0 Z"
          fill="#FFFFFF"
        ></path>
      </g>
    </svg>
  );
};

export const Drink = ({
  color = colors.primaryInvert,
  height = 25,
  width = 20,
  className = '',
}: IProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 20 25"
    >
      <g>
        <path
          fill={color}
          d="m17.05,6.64861l0,-5.2l-14.1,0l0,5.2c0,3.4 2.6,6.1 6.1,6.6l0,8.4l-3,0c0,0 -1.1,0 -1,1s1,0.9 1,0.9l8.7,0c0,0 0.9,0 1,-0.9c0,0 0,-0.9 -1,-0.9l-3.6,-0.1l0,-8.5c3.3,-0.4 5.9,-3.2 5.9,-6.5z"
        />
      </g>
    </svg>
  );
};

export const Info = ({ height = 25, className = '' }: IProps) => (
  <svg height={height} className={className} viewBox="0 0 330 330">
    <g>
      <path d="M165,0C74.019,0,0,74.02,0,165.001C0,255.982,74.019,330,165,330s165-74.018,165-164.999C330,74.02,255.981,0,165,0z M165,300c-74.44,0-135-60.56-135-134.999C30,90.562,90.56,30,165,30s135,60.562,135,135.001C300,239.44,239.439,300,165,300z" />
      <path d="M164.998,70c-11.026,0-19.996,8.976-19.996,20.009c0,11.023,8.97,19.991,19.996,19.991 c11.026,0,19.996-8.968,19.996-19.991C184.994,78.976,176.024,70,164.998,70z" />
      <path d="M165,140c-8.284,0-15,6.716-15,15v90c0,8.284,6.716,15,15,15c8.284,0,15-6.716,15-15v-90C180,146.716,173.284,140,165,140z" />
    </g>
  </svg>
);

export const Reload = ({ width = 38, height = 38, className = '' }: IProps) => (
  <svg width={width} height={height} className={className} viewBox="0 0 38 38">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="#2196F3" fillRule="nonzero">
        <path d="M6.29687509,9.2709306 C6.35546884,9.1928056 6.4140626,9.1146806 6.47265635,9.04046185 C6.3906251,9.1459306 6.30859384,9.25139935 6.22656259,9.3568681 C7.12890636,8.19280559 8.17187512,7.14593057 9.33203139,6.24358681 C9.22656264,6.32561806 9.12109389,6.40764931 9.01562513,6.48968056 C10.1875002,5.5873368 11.4726564,4.83343054 12.8359377,4.25530553 C12.7109377,4.30608678 12.5859377,4.36077428 12.4609377,4.41155553 C13.8593752,3.82561802 15.3281252,3.42718051 16.8320315,3.22405551 C16.6953127,3.24358676 16.5546877,3.26311801 16.417969,3.27874301 C17.9296878,3.07952426 19.4609378,3.07952426 20.9726566,3.27874301 C20.8359378,3.25921176 20.6953128,3.23968051 20.5585941,3.22405551 C22.0585941,3.42718051 23.5273441,3.82561802 24.9218754,4.41155553 C24.7968754,4.36077428 24.6718754,4.30608678 24.5468754,4.25530553 C25.9101566,4.82952429 27.1914067,5.5795243 28.3632817,6.48186806 C28.2578129,6.39983681 28.1523442,6.31780556 28.0468754,6.23577431 C29.2070317,7.13421182 30.2539067,8.18108684 31.1523442,9.3412431 C31.070313,9.23577435 30.9882817,9.1303056 30.9062505,9.02483685 C31.8085942,10.1967119 32.5585942,11.4779619 33.132813,12.8412432 C33.0820317,12.7162432 33.0273442,12.5912432 32.976563,12.4662431 C33.5625005,13.8607744 33.960938,15.3295244 34.164063,16.8295245 C34.1445318,16.6928057 34.1250005,16.5521807 34.1093755,16.415462 C34.3085943,17.9271807 34.3085943,19.462337 34.1093755,20.9740558 C34.1289068,20.837337 34.148438,20.696712 34.164063,20.5599933 C33.960938,22.0599933 33.5625005,23.5287433 32.976563,24.9232746 C33.0273442,24.7982746 33.0820317,24.6732746 33.132813,24.5482746 C32.5585942,25.9115558 31.8085942,27.1928059 30.9062505,28.3646809 C30.9882817,28.2592121 31.070313,28.1537434 31.1523442,28.0482746 C30.2539067,29.2084309 29.2070317,30.2553059 28.0468754,31.1537434 C28.1523442,31.0717122 28.2578129,30.9896809 28.3632817,30.9076497 C27.1914067,31.8099934 25.9101566,32.5599934 24.5468754,33.1342122 C24.6718754,33.083431 24.7968754,33.0287435 24.9218754,32.9779622 C23.5273441,33.5638997 22.0585941,33.9623372 20.5585941,34.1654622 C20.6953128,34.145931 20.8359378,34.1263997 20.9726566,34.1107747 C19.4609378,34.3099935 17.9257815,34.3099935 16.4140627,34.1107747 C16.5507815,34.130306 16.6914065,34.1498372 16.8281253,34.1654622 C15.3281252,33.9623372 13.8593752,33.5638997 12.4648439,32.9779622 C12.5898439,33.0287435 12.7148439,33.083431 12.8398439,33.1342122 C11.4765627,32.5599934 10.1953127,31.8099934 9.02343763,30.9076497 C9.12890639,30.9896809 9.23437514,31.0717122 9.33984389,31.1537434 C8.17968762,30.2553059 7.13281261,29.2084309 6.23437509,28.0482746 C6.31640634,28.1537434 6.3984376,28.2592121 6.48046885,28.3646809 C5.57812508,27.1928059 4.82812507,25.9115558 4.25390631,24.5482746 C4.30468756,24.6732746 4.35937506,24.7982746 4.41015632,24.9232746 C3.82421881,23.5287433 3.4257813,22.0599933 3.2226563,20.5599933 C3.24218755,20.696712 3.2617188,20.837337 3.2773438,20.9740558 C3.17968755,20.2162433 3.1289063,19.4584308 3.12500005,18.6928057 C3.12500005,17.8763995 2.40625004,17.0912432 1.56250002,17.1303057 C0.718750011,17.1693682 0,17.8178057 0,18.6928057 C0.00390625006,22.087337 0.933593764,25.4740558 2.70312504,28.3763996 C4.41406257,31.1849934 6.8750001,33.552181 9.7695314,35.1185872 C12.7695314,36.739681 16.2187502,37.5404623 19.6289065,37.3607748 C23.0078128,37.1810873 26.3398441,36.1068685 29.1367192,34.1967122 C31.8554692,32.3412434 34.117188,29.7943684 35.5312505,26.8138996 C37,23.7162433 37.6601568,20.2357745 37.2851568,16.8178057 C37.1015631,15.1224932 36.7343755,13.4623369 36.0937505,11.8763994 C35.4726568,10.3334306 34.695313,8.8724931 33.6875005,7.54827433 C32.6875005,6.23186806 31.570313,5.04046179 30.2617192,4.02483677 C29.5585942,3.47796177 28.8398442,2.96624301 28.0703129,2.5209305 C27.3046879,2.07561799 26.5,1.70452424 25.6835941,1.36468048 C22.3789066,-0.00250703629 18.7031253,-0.303288291 15.1953127,0.337336719 C11.5273439,1.00530548 8.07421887,2.87249301 5.44921883,5.5092118 C4.77343757,6.18889931 4.16796881,6.92718057 3.5976563,7.69280558 C3.3710938,7.99749308 3.34375005,8.54827434 3.4414063,8.8959306 C3.5429688,9.25921185 3.82031256,9.64983686 4.16015631,9.82952436 C4.52343757,10.0209306 4.96093757,10.1185869 5.36328133,9.98577436 C5.48828133,9.93499311 5.61328133,9.88030561 5.73828134,9.82952436 C5.97265634,9.69280561 6.15625009,9.50530561 6.29687509,9.2709306 L6.29687509,9.2709306 Z"></path>
        <path d="M11.5898439,7.18108682 C10.7851564,7.18108682 9.97656265,7.18108682 9.17187514,7.18108682 C7.88281262,7.18108682 6.59765635,7.18108682 5.30859383,7.18108682 C5.00781257,7.18108682 4.71093757,7.18108682 4.41015632,7.18108682 C4.92968757,7.70061808 5.45312508,8.22405559 5.97265634,8.74358684 C5.97265634,7.93889933 5.97265634,7.13030557 5.97265634,6.32561806 C5.97265634,5.03655554 5.97265634,3.75139927 5.97265634,2.46233675 C5.97265634,2.1615555 5.97265634,1.86468049 5.97265634,1.56389924 C5.97265634,0.747492975 5.25390633,-0.0376632868 4.41015632,0.00139921376 C3.56250005,0.0404617143 2.84765629,0.688899224 2.84765629,1.56389924 C2.84765629,2.36858675 2.84765629,3.17718051 2.84765629,3.98186802 C2.84765629,5.27093054 2.84765629,6.55608681 2.84765629,7.84514933 C2.84765629,8.14593059 2.84765629,8.44280559 2.84765629,8.74358684 C2.84765629,9.58733686 3.56250005,10.3060869 4.41015632,10.3060869 C5.21484383,10.3060869 6.02343759,10.3060869 6.8281251,10.3060869 C8.11718762,10.3060869 9.40234389,10.3060869 10.6914064,10.3060869 C10.9921877,10.3060869 11.2890627,10.3060869 11.5898439,10.3060869 C12.4062502,10.3060869 13.1914064,9.58733686 13.1523439,8.74358684 C13.1132814,7.89593058 12.4648439,7.18108682 11.5898439,7.18108682 L11.5898439,7.18108682 Z"></path>
      </g>
    </g>
  </svg>
);

export const Note = ({
  width = 24,
  height = 28,
  color = '#FFFFFF',
}: IProps) => (
  <svg width={width} height={height} viewBox="0 0 24 28">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-33.000000, -21.000000)"
        fill={color}
        fillRule="nonzero"
      >
        <g>
          <g transform="translate(33.000000, 21.000000)">
            <path d="M23.7,3.3 L20.7,0.3 C20.3,-0.1 19.7,-0.1 19.3,0.3 L6.3,13.3 C6.1,13.5 6,13.7 6,14 L6,17 C6,17.5 6.5,18 7,18 L10,18 C10.3,18 10.5,17.9 10.7,17.7 L23.7,4.7 C24.1,4.3 24.1,3.7 23.7,3.3 Z M9.6,16 L8,16 L8,14.4 L17,5.4 L18.6,7 L9.6,16 Z M20,5.6 L18.4,4 L20,2.4 L21.6,4 L20,5.6 Z"></path>
            <path d="M21,28 L1,28 C0.4,28 0,27.6 0,27 L0,3 C0,2.4 0.4,2 1,2 L13,2 C13.6,2 14,2.4 14,3 C14,3.6 13.6,4 13,4 L2,4 L2,26 L20,26 L20,11 C20,10.4 20.4,10 21,10 C21.6,10 22,10.4 22,11 L22,27 C22,27.6 21.6,28 21,28 Z"></path>
            <path d="M17,24 L5,24 C4.4,24 4,23.6 4,23 C4,22.4 4.4,22 5,22 L17,22 C17.6,22 18,22.4 18,23 C18,23.6 17.6,24 17,24 Z"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Cross = ({
  width = 14,
  height = 14,
  color = '#FF6238',
}: IProps) => (
  <svg width={width} height={height} viewBox="0 0 14 14">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-33.000000, -753.000000)"
        fill={color}
        fillRule="nonzero"
      >
        <g transform="translate(33.000000, 753.000000)">
          <g>
            <path d="M13.3797069,10.7620845 C14.1171747,11.5105147 14.108642,12.7152354 13.3602036,13.4522889 C12.9896413,13.8175651 12.5069352,14 12.0250416,14 C11.5333965,14 11.0421576,13.8106577 10.6699701,13.4327858 L7.01716839,9.727203 L3.23800172,13.4522889 C2.8670331,13.8175651 2.38473326,14 1.90243341,14 C1.41119457,14 0.919955723,13.8106577 0.547361826,13.4327858 C-0.190105919,12.6847619 -0.181166916,11.4800412 0.566865105,10.7425814 L4.34603177,7.01749559 L0.620092805,3.23796367 C-0.117374941,2.48953346 -0.108435938,1.28521905 0.639596084,0.547353004 C1.38762811,-0.189700415 2.59236192,-0.181574137 3.32982966,0.566856071 L7.05536231,4.34638799 L10.7622043,0.692813381 C11.5106427,-0.0442400383 12.7149701,-0.0357074464 13.4524379,0.712316448 C14.1899056,1.46034034 14.181373,2.66506106 13.4333409,3.4025208 L9.72649892,7.05609541 L13.3797069,10.7620845 Z"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
